import React from 'react';

import { Member } from './member';
import { GameContext } from '../../../../contexts/game';
import { PlayerState } from '../../../../types/state';

export const TeamMembers: React.FC<{
  selectedTeamCode: string;
  setSelectedPlayer: React.Dispatch<
    React.SetStateAction<PlayerState | undefined>
  >;
  setShowTeamList: React.Dispatch<React.SetStateAction<boolean>>;
  setShowPlayerChat: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  selectedTeamCode,
  setShowTeamList,
  setSelectedPlayer,
  setShowPlayerChat
}) => {
  const [game] = React.useContext(GameContext);

  const selectedTeam = React.useMemo(() => {
    return game.gameState?.teams?.find((team) => team.code === selectedTeamCode);
  }, [selectedTeamCode, game.gameState?.teams]);

  const members = React.useMemo(() => {
    return (
      game.gameState?.players?.filter(
        (player) => player.teamCode && player.teamCode === selectedTeamCode
      ) ?? []
    );
  }, [selectedTeamCode, game.gameState?.players]);

  return (
    <div>
      <div className={'mb-2'}>
        Team name: <strong>{selectedTeam?.name}</strong>
      </div>
      <div>
        {members.map((player) => (
          <Member
            player={player}
            key={player.code}
            setShowTeamList={setShowPlayerChat}
            setSelectedPlayer={setSelectedPlayer}
            setShowPlayerChat={setShowPlayerChat}
          />
        ))}
      </div>
    </div>
  );
};
